import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Avatar, Box, IconButton, Stack, Typography } from '@mui/material';
import type React from 'react';
import { parseUserNode, type UserNode } from '/@/hooks/nodes';
import { getInitials, getUserTypes } from '/@/utils';

export interface UserCardProps {
    userNode: UserNode;
    onWhatsAppClick?: (e?: React.MouseEvent) => void;
    onEmailClick?: (e?: React.MouseEvent) => void;
}

function UserCard({ userNode, onWhatsAppClick, onEmailClick }: UserCardProps) {
    // parseUserNode works fine without user parameter - it's optional
    const parsedUserNode = parseUserNode(userNode);
    const userTypes = getUserTypes();

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                padding: 2,
                borderRadius: 2,
                backgroundColor: '#FFFFFF',
                border: '1px solid #E0E0E0',
                boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)',
                width: '100%',
            }}
        >
            {/* Avatar with initials */}
            <Avatar
                sx={{
                    width: 48,
                    height: 48,
                    backgroundColor: '#F5F5F5',
                    color: '#10384F',
                    fontSize: '16px',
                    fontWeight: 700,
                }}
            >
                {getInitials(parsedUserNode.name || '')}
            </Avatar>

            {/* User information */}
            <Stack spacing={0.5} alignItems='flex-start' sx={{ flex: 1 }}>
                <Typography variant='overline' color='primary.mui.inactive'>
                    {userTypes[parsedUserNode.type as keyof typeof userTypes] || ''}
                </Typography>
                <Typography variant='body1' color='primary'>
                    {parsedUserNode.name || 'Sin nombre'}
                </Typography>
            </Stack>

            {/* Contact icons */}
            <Stack direction='row'>
                <IconButton
                    onClick={(e: React.MouseEvent) => {
                        e.stopPropagation();
                        onWhatsAppClick?.(e);
                    }}
                    color='primary'
                >
                    <WhatsAppIcon sx={{ fontSize: 24 }} />
                </IconButton>
                <IconButton
                    onClick={(e: React.MouseEvent) => {
                        e.stopPropagation();
                        onEmailClick?.(e);
                    }}
                    color='primary'
                >
                    <EmailOutlinedIcon sx={{ fontSize: 24 }} />
                </IconButton>
            </Stack>
        </Box>
    );
}

export default UserCard;
